import { Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ReplaySubject } from 'rxjs';

@Component({
    selector: 'app-instructions',
    templateUrl: './instructions.component.html',
    styleUrls: ['./instructions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InstructionsComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  data: any;
  sortedData: any[] = [];

  constructor(
    private mdr: MatDialogRef<InstructionsComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    this.data = data;
  }

  ngOnInit(): void {
    const customOrder = ["Concrete", "FTB", "Grout/Slurry", "Other", "Bulk"];

    this.sortedData = this.data.sort((a: { sampleTypeName: string; }, b: { sampleTypeName: string; }) => {
      const orderA = customOrder.indexOf(a.sampleTypeName);
      const orderB = customOrder.indexOf(b.sampleTypeName);

      const indexA = orderA !== -1 ? orderA : customOrder.length;
      const indexB = orderB !== -1 ? orderB : customOrder.length;

      return indexA - indexB;
    });
  }

  public closeDialog(): void {
    this.mdr.close();
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  hasNoInstructions(): boolean {
    return (this.data ?? []).every(
      (comment: any) => !comment.projectComment?.trim()
    );
  }
}
